import type { Locale } from './i18n';
import en from '@/locales/en.json';
import fr from '@/locales/fr.json';
import es from '@/locales/es.json';
import ru from '@/locales/ru.json';

export interface Translations {
  [key: string]: string | Translations;
}

const translations: Record<Locale, Translations> = { en, fr, es, ru };

export function getTranslations(locale: Locale): Translations {
  return translations[locale] ?? translations.en;
}

/** Get nested value by dot path, e.g. "nav.casinos" */
function getByPath(obj: unknown, path: string): string | undefined {
  const keys = path.split('.');
  let current: unknown = obj;
  for (const key of keys) {
    if (current == null || typeof current !== 'object') return undefined;
    current = (current as Record<string, unknown>)[key];
  }
  return typeof current === 'string' ? current : undefined;
}

/** Replace placeholders like {page} with values */
function interpolate(str: string, vars: Record<string, string | number>): string {
  return str.replace(/\{(\w+)\}/g, (_, key) => String(vars[key] ?? `{${key}}`));
}

export function t(translations: Translations, key: string, vars?: Record<string, string | number>): string {
  const value = getByPath(translations, key);
  const str = value ?? key;
  return vars ? interpolate(str, vars) : str;
}
